

export const index = 1;
export const component = async () => (await import('../entries/fallbacks/error.svelte.js')).default;
export const file = '_app/immutable/components/error.svelte-ebab9f9c.js';
export const imports = ["_app/immutable/components/error.svelte-ebab9f9c.js","_app/immutable/chunks/index-d33e9054.js","_app/immutable/chunks/stores-d30ca964.js","_app/immutable/chunks/singletons-8c64c647.js"];
export const stylesheets = [];
